<template>
  <Portal>
    <Modal
      data-testid="dynamicContentModal"
      :is-open="isOpen"
      size="md"
      @close="emit('close')"
    >
      <div class="container">
        <DynamicContent :title="title" :content="modalInfo" />
      </div>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            data-testid="close-button"
            label="Entendi"
            @click="emit('close')"
          />
        </template>
        <template v-if="costsButton" #button-secondary>
          <ButtonSecondary label="Ver Custos" @click="goToCosts" />
        </template>
      </ButtonContainer>
    </Modal>
  </Portal>
</template>

<script setup lang="ts">
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer,
  Modal
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import { Portal } from '@/modules/common/components/Portal';
import { IDynamicContent } from '@/modules/common/types';
import DynamicContent from '../DynamicContent/DynamicContent.vue';

const router = useRouter();

function goToCosts() {
  const url = router.resolve({ name: 'costs' }).href;
  window.open(url, '_blank');
}

defineProps<{
  modalInfo: IDynamicContent[];
  isOpen: boolean;
  title: string;
  costsButton: boolean;
}>();

const emit = defineEmits(['close']);
</script>

<style lang="less" scoped>
.container {
  padding: 0 @size-spacing-x500 @size-spacing-x600 @size-spacing-x500;
}

:deep(.modal-content) {
  padding: 0;
  align-items: flex-start;
}
</style>
